import axios from 'axios';
import { baseUri } from './baseUri';
import { ErrorWithData } from '../error/ErrorWithData';

export async function logOnOff() {
    const url = new URL('/Home/LogOn', baseUri).href;
    const response = await axios.post(url, undefined, {
        withCredentials: true,
    });
    if (response.status === 200) {
        return response.data;
    } else {
        throw new ErrorWithData(response, 'logOnOff failed');
    }
}
